import { setLocalePath } from "@/locales/index";
export const locale_file_path = "views.member_company_inquiry.";
/**
 * 언어팩 경로 셋팅 메서드
 * @param appendPath 추가로 붙일 경로 문자열
 * @returns
 */
export const autoLcMemberCompanyInquiry = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default {
    description: "바로고 업무처리에 관한 회원사 업무문의 입니다.",
    post_category_title: "게시물타입",
    user: "작성자",
    store: "상점",
    delete: "@:{'common.delete'}",
    edit: "@:{'common.edit'}",
    post_category: {
        work: "업무문의",
        van: "VAN관련문의",
        product: "물품요청",
        cancel_duplicated_payment: "중복결제 취소요청",
        posy_job_advertisement: "구인광고게시신청",
        connect_pos: "POS연동신청",
        chabge_business_number: "사업자번호변경신청",
        vat_reference: "부가세 참고자료",
        entry_kakao_talk_order: "카카오톡 주문하기 입점신청",
        connrct_baemin_server: "배달의민족 서버연동요청",
        bike_lease_aj_bike: "바이크리스신청(AJ바이크)",
        bike_lease_bike_master: "바이크리스신청(바이크마스터)",
        bike_lease_bike_bank: "바이크리스신청(바이크뱅크)",
        apply_albamon: "알바몬신청",
        cancel_albmon: "알바몬해지",
        apply_alba_heaven: "알바천국신청",
        cancel_alba_heaven: "알바천국해지",
        bike_lease: "바이크리스신청",
        job_service: "채용서비스신청",
    },
    list: {
        create: "신규 등록",
        page_title: "회원사 업무문의",
        table: {
            id: "번호",
            target_Type: "대상",
            type: "타입",
            processing_Type: "상태",
            title: "제목",
            created_By: "작성자",
            created_time: "등록일",
            deleted_content: "삭제된 내용입니다.",
        },
    },
    detail: {
        detail_view: "상세보기 (No. {id})",
        comment: "덧글 목록",
    },
    processingType: {
        received: "접수",
        in_progress: "진행",
        done: "완료",
        already_accepted_van: "기등록벤",
        rejected: "반려",
        no: "제외",
    },
    placeholder: {
        title: "제목을 입력해 주세요.",
        body: "내용을 입력해 주세요.",
    },
    form: {
        author: "작성자",
        target: "대상",
        body: "내용",
        origin_body: "원본 내용",
    },
    delete_alert: {
        head: "회원사 업무문의 삭제",
        body: "해당 글을 삭제 하시겠습니까?",
        body_with_id: "{id}번 업무문의 삭제 하시겠습니까?",
    },
};
